// extracted by mini-css-extract-plugin
export default {"desktop":"desktop","lcpFixer":"dIJcSxtO","mobile":"mobile","socializator":"UQmuYlv4","subscribe":"w_B2yHI9","cover":"eUExmKWF","text":"jdqIrYfQ"};